import { fetchSettings } from "@/lib/api";

function injectPixel(id) {
  if (window.fbq) return;
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  window.fbq("init", id);
  window.fbq("track", "PageView");
}

function injectGtag(id) {
  if (window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);
}

export async function loadAnalytics() {
  try {
    const s = await fetchSettings();
    if (s.meta_pixel_id) injectPixel(s.meta_pixel_id);
    if (s.ga_id) injectGtag(s.ga_id);
    if (s.meta_pixel_id || s.ga_id) track("ViewContent", { content_name: "The 7-Night Sleep Reset", value: 19.95, currency: "USD" });
  } catch (e) {
    /* analytics are non-blocking */
  }
}

export function track(event, data = {}) {
  if (window.fbq) window.fbq("track", event, data);
  if (window.gtag) window.gtag("event", event, data);
}
